/**
 * Query key factory for LLM providers.
 * Follows the same pattern as connectors.keys.ts.
 */
export const llmProviderKeys = {
  all: ["llm-providers"] as const,
  lists: () => [...llmProviderKeys.all, "list"] as const,
  list: () => [...llmProviderKeys.lists()] as const,
  details: () => [...llmProviderKeys.all, "detail"] as const,
  detail: (id: string) => [...llmProviderKeys.details(), id] as const,
};
